import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project import
// import Logo from './LogoMain';
// import LogoIcon from './LogoIcon';
import IOMarket from 'assets/images/icons/logo-icon-io.svg';
import IOMarketLogo from 'assets/images/icons/gate2bLogoWhiteTheme.png';
import whiteTheme from 'assets/images/icons/download.svg';
import WhiteThemeIOMarketLogo from 'assets/images/icons/gate2bLogoDarkTheme.png';
import  hilconaMob from '../../assets/images/mob-image/hilcona_mob_size.png';
import  repowerMob from '../../assets/images/mob-image/repower-mob_size.png';
import  lindenhofgruppeMob from '../../assets/images/mob-image/lindenhofgruppe_mob_size.png';
import  iomarketMob from '../../assets/images/mob-image/favi.svg';
import xatenaLogo from 'assets/images/icons/xatenaLogo.png';
import xatena from 'assets/images/icons/xatena.png';

import { APP_DEFAULT_PATH } from 'config';
import { useTheme } from '@mui/material/styles';
import { getDomainName, getEncryptedItem } from 'utils/commonFunctions';
// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const domain = getDomainName();
const isIONetgateDomain = domain.includes('io-netgate');

const logIcons:any = {
  'hilcona': hilconaMob,
  'repower': repowerMob,
  'lindenhofgruppe': lindenhofgruppeMob,
  'io-market': iomarketMob
};

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => {
  const theme = useTheme();
  // const location = useLocation();

  return (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={sx}>
      {isIONetgateDomain?
        (isIcon ? (
            <img src={logIcons[JSON.parse(getEncryptedItem('logo')||'')['instance']] || IOMarket} style={{ width: '85%' }} />
          ) : (
            <img src={theme.palette.mode === 'dark' ? getEncryptedItem('logo') && process.env.REACT_APP_IMAGE_URL + JSON.parse(getEncryptedItem('logo')||'')['dark']
              : getEncryptedItem('logo') && process.env.REACT_APP_IMAGE_URL + JSON.parse(getEncryptedItem('logo')||'')['white']} 
              style={{ marginTop:'15px', width: '75%' }} />
          ))
      :
        window.location.host.split('.').includes('xatena') ?
          (isIcon ? (
            <img src={xatena} style={{ width: '100%' }} />
          ) : (
            <img src={xatenaLogo} style={{ width: '50%', marginRight: '5rem' }} />
          ))
          :
          (isIcon ? (
            <img src={theme.palette.mode === 'dark' ? whiteTheme : IOMarket} style={{ width: '85%' }} />
          ) : (
            <img src={theme.palette.mode === 'dark' ? WhiteThemeIOMarketLogo : IOMarketLogo} style={{ width: '60%', marginRight: ' 90px' }} />
          ))
      }
    </ButtonBase>
  );
};

export default LogoSection;
